import { createRef, memo, useCallback, useEffect } from 'react';

import PageTitle from 'components/PageTitle';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { orderBumpService } from 'services';
import { PageColumn } from 'shared';
import AlertDialog, { IAlertDialog } from 'shared/AlertDialog';
import { selectOrderBumpForm } from 'store/selectors';

import ArrowLeft from '@eduzz/houston-icons/ArrowLeft';

import Form from './Form';
import { BackButton } from './styles';

const OrderBumpForm = () => {
  const navigate = useNavigate();

  const { mainProduct = null } = useSelector(selectOrderBumpForm);

  useEffect(() => {
    return function resetFormState() {
      orderBumpService.resetFormState();
    };
  }, []);

  const handleClickBackButton = useCallback(() => {
    navigate('/orderbump', { replace: true });
  }, [navigate]);

  const refAlertDialog = createRef<IAlertDialog>();

  const handleCancelForm = useCallback(() => {
    if (!mainProduct?.contentId) {
      handleClickBackButton();
    }

    refAlertDialog.current?.showAlertDialog({
      title: 'Atenção',
      text: 'Você não salvou suas alterações. Deseja sair sem salvar?',
      confirmActionTextButton: 'Continuar editando',
      cancelActionTextButton: 'Descartar alterações',
      onCancel: handleClickBackButton
    });
  }, [refAlertDialog, mainProduct?.contentId, handleClickBackButton]);

  return (
    <>
      <BackButton variant='text' startIcon={<ArrowLeft />} onClick={handleCancelForm}>
        Voltar
      </BackButton>
      <PageColumn>
        <PageTitle title='Configurar Order Bump' />
      </PageColumn>
      <Form handleCancelForm={handleCancelForm} />
      <AlertDialog ref={refAlertDialog} />
    </>
  );
};

export default memo(OrderBumpForm);
